
import React from 'react';
import { useSidebarLogo } from '@/hooks/useOfflineLogo';

export const SidebarHeader: React.FC = () => {
  const { logoUrl, isFromCache, isLoading, error } = useSidebarLogo();

  return (
    <div className="flex flex-col items-center p-4 border-b border-gray-200">
      {isLoading ? (
        <div className="h-64 w-full flex items-center justify-center">
          <div className="animate-pulse bg-gray-200 h-32 w-32 rounded"></div>
        </div>
      ) : error ? (
        <img
          src="/lovable-uploads/309c4bff-08a2-44a3-9eb8-307bc935b2a8.png"
          alt="The Mat Monster Logo"
          className="h-64 object-contain"
          title={`Fallback logo (${error})`}
        />
      ) : (
        <img
          src={logoUrl}
          alt="The Mat Monster Logo"
          className="h-64 object-contain"
          title={isFromCache ? 'Cached logo (offline ready)' : 'Online logo'}
        />
      )}
    </div>
  );
};
